import { create } from 'zustand';

/**
 * Cross-mount selection state for the Providers page (IMP-006).
 *
 * Maria, 2026-06-01 Slack 15:08 (meeting recap):
 *   "Update the last 3 tabs so that they retain the data when a user
 *    clicks away and comes back to it."
 *
 * See `detailSelectionStore.ts` for the architecture rationale
 * (mirroring Map's in-memory zustand pattern rather than URL-sync or
 * persist-middleware).
 *
 * Three fields mirror what ProvidersTable previously held in local
 * `useState`: free-text `search`, the OG chip-slug `occupationalGroupId`,
 * and `metroAreaId`. The chip-slug -> backend name resolution
 * (`lookupSectorByChipId`) stays in the page; the store holds the
 * raw slug exactly as the dropdown emits it.
 */
interface ProvidersSelectionStore {
  readonly search: string;
  readonly occupationalGroupId: string;
  readonly metroAreaId: string;
  setSearch: (s: string) => void;
  setOccupationalGroupId: (id: string) => void;
  setMetroAreaId: (id: string) => void;
  reset: () => void;
}

export const useProvidersSelectionStore = create<ProvidersSelectionStore>((set) => ({
  search: '',
  occupationalGroupId: '',
  metroAreaId: '',
  setSearch: (s) => set({ search: s }),
  setOccupationalGroupId: (id) => set({ occupationalGroupId: id }),
  setMetroAreaId: (id) => set({ metroAreaId: id }),
  reset: () => set({ search: '', occupationalGroupId: '', metroAreaId: '' }),
}));
